import type { DeepPartial } from '../../default/types';
import type { OrderConfig } from '../../default/order/order.types';

export const orderConfig: DeepPartial<OrderConfig> = {
  paymentMethods: ['paypal', 'mastercard', 'visa', 'diners', 'discover'],
  hasCo2Compensation: false,
  externalUrls: {
    rsvAvb: {
      default: 'https://www.universal.at/de/ratenschutz/avb/',
    },
    rsvIpid: {
      default: 'https://www.universal.at/de/ratenschutz/ipid/',
    },
    rsvInfoVag: {
      default: 'https://www.universal.at/de/ratenschutz/fernfing/',
    },
    rsvVvi: {
      default: 'https://www.universal.at/de/ratenschutz/ruecktrittsrecht/',
    },
    rsvWithdrawalRight: {
      default: 'https://www.universal.at/de/ratenschutz/ruecktrittsrecht/',
    },
    rsvDataProtection: {
      default: 'https://bnpparibascardif.at/datenschutz/',
    },
  },
  premium: {
    enabled: false,
    hasRuntimeOptions: false,
    hasLegalFooter: true,
  },
  paylink: {
    paymentMethods: ['mastercard', 'visa', 'diners', 'discover'],
  },
};
